function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnNearfield({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 150",
    d: "M9.61 18.6a1 1 0 0 1-2 0A12.87 12.87 0 0 1 20.54 5.71a1 1 0 0 1 0 2A11 11 0 0 0 9.61 18.6zm10.93-7.8a7.8 7.8 0 0 0-7.78 7.8 1 1 0 0 0 2 0 5.79 5.79 0 0 1 1.71-4.12 5.68 5.68 0 0 1 4.11-1.72.981.981 0 1 0-.04-1.96zm11.81 9.09V20a2.55 2.55 0 0 1 0 .39V31A3.35 3.35 0 0 1 29 34.29h-6.51A3.36 3.36 0 0 1 19.13 31V20.43a3.36 3.36 0 0 1 3.36-3.35H29a4.08 4.08 0 0 1 .94.13l.44.12V15.6a1 1 0 1 1 2 0zm-2 .54A1.38 1.38 0 0 0 29 19.05h-6.51a1.38 1.38 0 0 0-1.39 1.38V31a1.38 1.38 0 0 0 1.39 1.38H29A1.38 1.38 0 0 0 30.39 31z",
    style: {
      fill: "#5e5e5d"
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnNearfield);
export default __webpack_public_path__ + "static/media/icn-nearfield.6eb513f28cb062575ab218a5b55fbf4e.svg";
export { ForwardRef as ReactComponent };